import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isValid } from 'date-fns';

import { getStartDate, getEndDate } from '../../../../store/selectors/package';
import { formatDateToDayWithMonth } from '../../../../../../utils/dateUtils';
import HintButton from '../../../../../../components/HintButton';

const EmptyTimeTooltipContainer = (props) => {
  const { departure, type, startDate, endDate, ...rest } = props;

  const isValidDate = departure && isValid(new Date(departure));
  const prepareDate = type === 'to' ? startDate : endDate;
  const date = isValidDate ? departure : prepareDate;

  return (
    <HintButton
      dataAttr="empty-time"
      text={formatDateToDayWithMonth(date)}
      {...rest}
    />
  );
};

EmptyTimeTooltipContainer.defaultProps = {
  departure: null,
};
EmptyTimeTooltipContainer.propTypes = {
  type: PropTypes.oneOf(['back', 'to']).isRequired,
  departure: PropTypes.instanceOf(Date),
};

const mapStateToProps = (state) => ({
  startDate: getStartDate(state),
  endDate: getEndDate(state),
});

export default connect(mapStateToProps)(EmptyTimeTooltipContainer);
